var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0C5.71924 0 0 5.7199 0 12.75C0 22.1562 11.7636 33.3359 12.2644 33.8077C12.4014 33.9357 12.5757 34 12.75 34C12.9243 34 13.0986 33.9357 13.2356 33.8077C13.7364 33.3359 25.5 22.1562 25.5 12.75C25.5 5.7199 19.7808 0 12.75 0ZM12.75 19.8334C8.84445 19.8334 5.66664 16.6556 5.66664 12.75C5.66664 8.84445 8.84452 5.66664 12.75 5.66664C16.6555 5.66664 19.8334 8.84452 19.8334 12.75C19.8334 16.6555 16.6556 19.8334 12.75 19.8334Z",
    fill: "#744DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.68577152c8aa1d744c73d4abd3ce7fc7.svg";
export { ForwardRef as ReactComponent };